import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-10-06T09:48:01-0400.
 */
export function useWoAttachmentsAuthorizationEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.WoAttachmentsAuthorization,
    false
  );

  return Boolean(isEnabled);
}
